import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import FooterShade from "../partials/footer";
// import ShareButtons from "../components/sharebuttons";
import Cookies from "universal-cookie";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome'
import {
  faFacebookSquare
}
from '@fortawesome/free-brands-svg-icons'
import {
  faTwitterSquare
}
  from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
const cookies = new Cookies();

class Galerija extends Component {
  render() {
    const props = this.props;

    if (!props.data.foto) {
      return <p>...</p>;
    }


    const masonry_images = this.props.data.foto.galerijas.foto.map((prop, i) => {
      //console.log(prop.sourceUrl);
      return (
        
          <img src={prop.sourceUrl} alt={prop.title} key={i} className={`img-grid-item`} />
      );
    });

    const generateRandomBetween = (min, max, exclude) => {
    let ranNum = Math.floor(Math.random() * (max - min)) + min;

    if (ranNum === exclude) {
        ranNum = generateRandomBetween(min, max, exclude);
    }

    return ranNum;  
}    

    const numImages = this.props.data.foto.galerijas.foto.length;
const randnumber = generateRandomBetween(0, numImages-1);  

    //console.log(CarouselIndicators);
    return (
      <React.Fragment>
        <div id = "singleGalerija" data-headertitle = {
          cookies.get("lang") === "LV" ? "< Galerijas" : cookies.get("lang") === "EN" ? "< Galleries" : null
        } >
        <div id="carouselIdGal" className="carousel slide narrow-carousel" data-ride="carousel">

          <div className="carousel-inner" role="listbox">
            <div
          className="carousel-item active"
          key="0"
          style={{
            backgroundImage: `url(${this.props.data.foto.galerijas.foto[randnumber].sourceUrl})`
          }}
        ></div>
            <div className="carousel-item-herotextnarrow-wrap">
              <div className = "herotext herotext__left herotext__morebottom" >
                {/* {cookies.get("lang") === "LV" && props.data.foto.title !== null ? props.data.foto.title : props.data.foto.translation.title}
                {cookies.get("lang") === "EN" && props.data.foto.translation.title !== null ? props.data.foto.translation.title : props.data.foto.title} */}
{/* 
                {cookies.get("lang") === "LV" && props.data.foto.title
                  ?
                  props.data.foto.title
                  :
                  props.data.foto.translation.title
                    ?
                    cookies.get("lang") === "EN" && props.data.foto.translation.title
                    :
                    props.data.foto.translation.title
                      ?
                      props.data.foto.title
              } */}
                
                {/* {cookies.get("lang") === "LV" && props.data.foto.title !== null ? props.data.foto.title : cookies.get("lang") === "EN" && props.data.foto.translation.title ? props.data.foto.translation.title : null
                } */}
                {props.data.foto.title}

                

              </div>
            </div>
          </div>
          <FooterShade />
        </div>
        <div className="gal_info_row">
            <div className="single-share-btns">
              <span>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage
                    .singlePostShareButtonsText}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage
                    .singlePostShareButtonsTextEn}
              </span>
              <span>
    <a
      href={'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkanepes.lv/'+cookies.get("lang").toLowerCase()+'/foto/' + this.props.data.foto.slug + '&quote=Kaņepes%20Kultūras%20Centrs - '+ this.props.data.foto.title}
      target="_blank"
      rel="noopener noreferrer"
      title="Share on Facebook"
      className="share-icon"
      onClick={() =>
        "window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.URL) + '&quote=' + encodeURIComponent(document.URL)); return false;"
      }
    >
      <FontAwesomeIcon icon={faFacebookSquare} />
      <span className="sr-only">Share on Facebook</span>
    </a>
    <a
      href={'https://twitter.com/intent/tweet?source=https%3A%2F%2Fkanepes.lv/'+cookies.get("lang").toLowerCase()+'/foto/' + this.props.data.foto.slug + '&text=Kaņepes%20Kultūras%20Centrs - '+this.props.data.foto.title + ' https%3A%2F%2Fkanepes.lv/'+cookies.get("lang").toLowerCase()+'/foto/' + this.props.data.foto.slug+'&via=kanepeskc'}
      target="_blank"
      rel="noopener noreferrer"
      title="Tweet"
      className="share-icon"
      onClick={() =>
        "window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(document.title) + ':%20' + encodeURIComponent(document.URL)); return false;"
      }
    >
      <FontAwesomeIcon icon={faTwitterSquare} />
      <span className="sr-only">Tweet</span>
    </a>
    <a
      href={'mailto:?subject=Kaņepes Kultūras centrs - '+this.props.data.foto.title + '&body=https%3A%2F%2Fkanepes.lv/'+cookies.get("lang").toLowerCase()+'/foto/' + this.props.data.foto.slug}
      target="_blank"
      rel="noopener noreferrer"
      title="Share via E-mail"
      className="share-icon"
    >
      <FontAwesomeIcon icon={faEnvelope} />
      <span className="sr-only">E-mail</span>
    </a>
  </span>
            </div>

        </div>
          <div className="row justify-content-center m-0">
          <div className="col-12 mt-5 gallery_masonry_wrap">
            <div className="gallery_masonry">
        <SimpleReactLightbox>
              <SRLWrapper>{masonry_images}</SRLWrapper>
          </SimpleReactLightbox>
          
        </div>
          </div>
          </div>
          </div>
      </React.Fragment>
    );
  }
}

const GetGalerijaBySlug = gql`
  query galerijas($slug: ID!) {
    foto(id: $slug, idType: URI) {
      title
      galerijas {
        foto {
          sourceUrl(size: MEDIUM_LARGE)
        }
      }
      slug
    }
    themeGeneralSettings {
      optionsPage {
        singlePostShareButtonsText
      }
    }
  }
`;

export default graphql(GetGalerijaBySlug, {
  options: props => {
    const slug = props.match.params.slug;
    return {
      variables: {
        slug
      }
    };
  }
})(Galerija);
